// Templates de tâches pour chaque type d'événement

export interface TaskTemplate {
  title: string;
  description: string;
  category: string;
  priority: 'low' | 'medium' | 'high';
  daysBeforeEvent: number; // Nombre de jours avant l'événement
}

// Templates pour Mariage
export const weddingTaskTemplates: TaskTemplate[] = [
  // 12 mois avant (365 jours)
  {
    title: 'Définir le budget global',
    description: 'Établir un budget détaillé pour chaque poste de dépense du mariage',
    category: 'planning',
    priority: 'high',
    daysBeforeEvent: 365
  },
  {
    title: 'Choisir la date du mariage',
    description: 'Fixer la date en fonction des disponibilités du lieu et des prestataires',
    category: 'planning',
    priority: 'high',
    daysBeforeEvent: 365
  },
  {
    title: 'Rechercher le lieu de réception',
    description: 'Visiter et comparer différents lieux pour la cérémonie et la réception',
    category: 'venue',
    priority: 'high',
    daysBeforeEvent: 350
  },
  
  // 9 mois avant (270 jours)
  {
    title: 'Réserver les prestataires principaux',
    description: 'Photographe, traiteur, DJ/orchestre, fleuriste',
    category: 'vendors',
    priority: 'high',
    daysBeforeEvent: 270
  },
  {
    title: 'Commander les tenues',
    description: 'Robe de mariée, costume du marié et tenues des témoins',
    category: 'attire',
    priority: 'high',
    daysBeforeEvent: 270
  },
  {
    title: 'Choisir les témoins',
    description: 'Demander officiellement aux témoins de participer au mariage',
    category: 'ceremony',
    priority: 'medium',
    daysBeforeEvent: 270
  },
  
  // 6 mois avant (180 jours)
  {
    title: 'Commander les faire-part',
    description: 'Design, impression et commande des invitations',
    category: 'guests',
    priority: 'medium',
    daysBeforeEvent: 180
  },
  {
    title: 'Planifier le menu',
    description: 'Définir le menu avec le traiteur, prévoir les alternatives alimentaires',
    category: 'reception',
    priority: 'medium',
    daysBeforeEvent: 180
  },
  {
    title: 'Réserver les hébergements',
    description: 'Bloquer des chambres d\'hôtel pour les invités',
    category: 'guests',
    priority: 'medium',
    daysBeforeEvent: 180
  },
  
  // 3 mois avant (90 jours)
  {
    title: 'Envoyer les faire-part',
    description: 'Envoyer les invitations et commencer à gérer les RSVP',
    category: 'guests',
    priority: 'high',
    daysBeforeEvent: 90
  },
  {
    title: 'Finaliser la décoration',
    description: 'Commander les fleurs, la décoration de table et autres éléments décoratifs',
    category: 'reception',
    priority: 'medium',
    daysBeforeEvent: 90
  },
  
  // 1 mois avant (30 jours)
  {
    title: 'Essayage final des tenues',
    description: 'Derniers ajustements des tenues de mariage',
    category: 'attire',
    priority: 'medium',
    daysBeforeEvent: 30
  },
  {
    title: 'Confirmer les détails avec les prestataires',
    description: 'Reconfirmer les horaires et détails avec tous les prestataires',
    category: 'vendors',
    priority: 'high',
    daysBeforeEvent: 30
  }
];

// Templates pour Anniversaire
export const birthdayTaskTemplates: TaskTemplate[] = [
  // 2 mois avant (60 jours)
  {
    title: 'Choisir le thème de la fête',
    description: 'Définir le thème et l\'ambiance de l\'anniversaire',
    category: 'planning',
    priority: 'high',
    daysBeforeEvent: 60
  },
  {
    title: 'Réserver le lieu',
    description: 'Trouver et réserver l\'endroit pour célébrer',
    category: 'venue',
    priority: 'high',
    daysBeforeEvent: 50
  },
  {
    title: 'Établir la liste des invités',
    description: 'Dresser la liste des personnes à inviter',
    category: 'guests',
    priority: 'medium',
    daysBeforeEvent: 45
  },
  
  // 1 mois avant (30 jours)
  {
    title: 'Envoyer les invitations',
    description: 'Envoyer les invitations par email, SMS ou courrier',
    category: 'guests',
    priority: 'high',
    daysBeforeEvent: 30
  },
  {
    title: 'Commander le gâteau',
    description: 'Choisir et commander le gâteau d\'anniversaire',
    category: 'catering',
    priority: 'medium',
    daysBeforeEvent: 21
  },
  {
    title: 'Planifier les activités',
    description: 'Organiser les jeux, animations et divertissements',
    category: 'entertainment',
    priority: 'medium',
    daysBeforeEvent: 21
  },
  
  // 2 semaines avant (14 jours)
  {
    title: 'Acheter les décorations',
    description: 'Ballons, guirlandes, et autres éléments décoratifs',
    category: 'decoration',
    priority: 'medium',
    daysBeforeEvent: 14
  },
  {
    title: 'Prévoir la nourriture et boissons',
    description: 'Planifier le menu et faire les courses',
    category: 'catering',
    priority: 'high',
    daysBeforeEvent: 14
  },
  
  // 1 semaine avant (7 jours)
  {
    title: 'Confirmer les présences',
    description: 'Relancer les invités qui n\'ont pas encore répondu',
    category: 'guests',
    priority: 'medium',
    daysBeforeEvent: 7
  },
  {
    title: 'Préparer la playlist',
    description: 'Sélectionner la musique pour l\'ambiance',
    category: 'entertainment',
    priority: 'low',
    daysBeforeEvent: 7
  }
];

// Templates pour Fiançailles
export const engagementTaskTemplates: TaskTemplate[] = [
  // 1 mois avant (30 jours)
  {
    title: 'Choisir la date et l\'heure',
    description: 'Fixer le moment pour annoncer les fiançailles',
    category: 'planning',
    priority: 'high',
    daysBeforeEvent: 30
  },
  {
    title: 'Réserver le lieu',
    description: 'Trouver l\'endroit parfait pour la célébration',
    category: 'venue',
    priority: 'high',
    daysBeforeEvent: 25
  },
  {
    title: 'Établir la liste des invités',
    description: 'Décider qui inviter pour partager ce moment spécial',
    category: 'guests',
    priority: 'medium',
    daysBeforeEvent: 20
  },
  
  // 3 semaines avant (21 jours)
  {
    title: 'Envoyer les invitations',
    description: 'Inviter famille et amis proches',
    category: 'guests',
    priority: 'high',
    daysBeforeEvent: 21
  },
  {
    title: 'Organiser la décoration',
    description: 'Prévoir une décoration romantique et élégante',
    category: 'decoration',
    priority: 'medium',
    daysBeforeEvent: 14
  },
  {
    title: 'Planifier le menu',
    description: 'Choisir un menu festif pour l\'occasion',
    category: 'catering',
    priority: 'medium',
    daysBeforeEvent: 14
  },
  
  // 1 semaine avant (7 jours)
  {
    title: 'Prévoir le photographe',
    description: 'Organiser la prise de photos pour immortaliser le moment',
    category: 'photography',
    priority: 'medium',
    daysBeforeEvent: 7
  },
  {
    title: 'Préparer le discours',
    description: 'Réfléchir aux mots pour annoncer les fiançailles',
    category: 'ceremony',
    priority: 'low',
    daysBeforeEvent: 7
  }
];

// Templates pour Baby Shower
export const babyShowerTaskTemplates: TaskTemplate[] = [
  // 6 semaines avant (42 jours)
  {
    title: 'Choisir le thème',
    description: 'Sélectionner un thème mignon pour le baby shower',
    category: 'planning',
    priority: 'high',
    daysBeforeEvent: 42
  },
  {
    title: 'Fixer la date',
    description: 'Choisir une date qui convient à la future maman',
    category: 'planning',
    priority: 'high',
    daysBeforeEvent: 35
  },
  {
    title: 'Réserver le lieu',
    description: 'Trouver un endroit confortable pour la célébration',
    category: 'venue',
    priority: 'high',
    daysBeforeEvent: 30
  },
  
  // 1 mois avant (30 jours)
  {
    title: 'Établir la liste des invités',
    description: 'Lister famille et amies proches',
    category: 'guests',
    priority: 'medium',
    daysBeforeEvent: 30
  },
  {
    title: 'Envoyer les invitations',
    description: 'Invitations avec le thème choisi',
    category: 'guests',
    priority: 'high',
    daysBeforeEvent: 28
  },
  {
    title: 'Créer la liste de naissance',
    description: 'Aider à établir une liste de cadeaux utiles',
    category: 'gifts',
    priority: 'medium',
    daysBeforeEvent: 25
  },
  
  // 2 semaines avant (14 jours)
  {
    title: 'Organiser les jeux',
    description: 'Préparer des activités amusantes sur le thème bébé',
    category: 'entertainment',
    priority: 'medium',
    daysBeforeEvent: 14
  },
  {
    title: 'Commander le gâteau',
    description: 'Gâteau personnalisé sur le thème du baby shower',
    category: 'catering',
    priority: 'medium',
    daysBeforeEvent: 10
  },
  {
    title: 'Acheter les décorations',
    description: 'Ballons, guirlandes et accessoires thématiques',
    category: 'decoration',
    priority: 'medium',
    daysBeforeEvent: 7
  }
];

// Templates pour Baptême
export const baptismTaskTemplates: TaskTemplate[] = [
  // 2 mois avant (60 jours)
  {
    title: 'Contacter l\'église/lieu de cérémonie',
    description: 'Réserver la date et organiser la cérémonie religieuse',
    category: 'ceremony',
    priority: 'high',
    daysBeforeEvent: 60
  },
  {
    title: 'Choisir les parrains/marraines',
    description: 'Sélectionner et demander aux futurs parrains et marraines',
    category: 'ceremony',
    priority: 'high',
    daysBeforeEvent: 50
  },
  
  // 1 mois avant (30 jours)
  {
    title: 'Organiser la réception',
    description: 'Réserver le lieu pour la fête après la cérémonie',
    category: 'venue',
    priority: 'high',
    daysBeforeEvent: 30
  },
  {
    title: 'Envoyer les invitations',
    description: 'Inviter famille et amis pour la cérémonie et la réception',
    category: 'guests',
    priority: 'high',
    daysBeforeEvent: 30
  },
  {
    title: 'Choisir la tenue de baptême',
    description: 'Sélectionner la robe ou tenue traditionnelle',
    category: 'attire',
    priority: 'medium',
    daysBeforeEvent: 25
  },
  
  // 2 semaines avant (14 jours)
  {
    title: 'Commander le gâteau',
    description: 'Gâteau de baptême traditionnel ou personnalisé',
    category: 'catering',
    priority: 'medium',
    daysBeforeEvent: 14
  },
  {
    title: 'Organiser la décoration',
    description: 'Décoration sobre et élégante pour la réception',
    category: 'decoration',
    priority: 'medium',
    daysBeforeEvent: 10
  },
  {
    title: 'Prévoir le photographe',
    description: 'Immortaliser ce moment important',
    category: 'photography',
    priority: 'medium',
    daysBeforeEvent: 7
  }
];

// Templates pour Autres événements
export const otherEventTaskTemplates: TaskTemplate[] = [
  // 1 mois avant (30 jours)
  {
    title: 'Définir l\'objectif de l\'événement',
    description: 'Clarifier le but et le type de célébration',
    category: 'planning',
    priority: 'high',
    daysBeforeEvent: 30
  },
  {
    title: 'Fixer la date et l\'heure',
    description: 'Choisir le moment optimal pour l\'événement',
    category: 'planning',
    priority: 'high',
    daysBeforeEvent: 25
  },
  {
    title: 'Réserver le lieu',
    description: 'Trouver et réserver l\'endroit approprié',
    category: 'venue',
    priority: 'high',
    daysBeforeEvent: 20
  },
  
  // 3 semaines avant (21 jours)
  {
    title: 'Établir la liste des invités',
    description: 'Déterminer qui inviter selon le type d\'événement',
    category: 'guests',
    priority: 'medium',
    daysBeforeEvent: 21
  },
  {
    title: 'Envoyer les invitations',
    description: 'Informer les invités de l\'événement',
    category: 'guests',
    priority: 'high',
    daysBeforeEvent: 18
  },
  
  // 2 semaines avant (14 jours)
  {
    title: 'Planifier le programme',
    description: 'Organiser le déroulement de l\'événement',
    category: 'planning',
    priority: 'medium',
    daysBeforeEvent: 14
  },
  {
    title: 'Organiser la restauration',
    description: 'Prévoir nourriture et boissons adaptées',
    category: 'catering',
    priority: 'medium',
    daysBeforeEvent: 10
  },
  {
    title: 'Préparer la décoration',
    description: 'Décorer selon le thème de l\'événement',
    category: 'decoration',
    priority: 'medium',
    daysBeforeEvent: 7
  }
];

// Export des templates par type d'événement
export const eventTaskTemplates = {
  wedding: weddingTaskTemplates,
  birthday: birthdayTaskTemplates,
  engagement: engagementTaskTemplates,
  babyshower: babyShowerTaskTemplates,
  baptism: baptismTaskTemplates,
  other: otherEventTaskTemplates
};

// Fonction utilitaire pour obtenir les templates d'un type d'événement
export function getTaskTemplatesForEventType(eventType: string): TaskTemplate[] {
  return eventTaskTemplates[eventType as keyof typeof eventTaskTemplates] || otherEventTaskTemplates;
} 